import { createContext } from "react";
const BreadcrumbsContext = createContext({
  breadcrumbs: [],
  saveBreadcrumbs: null,
  renameLastBreadcrumb: null
});
export {
  BreadcrumbsContext
};
//# sourceMappingURL=types.js.map
